import { accessRole } from '../../../../helpers/access_role'
import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend, Input, Label,Tooltip
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import CustomSelect from '../../../../helpers/ui/CustomSelect'
import { AvForm, AvGroup, AvInput, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import { Link, useHistory, Redirect } from "react-router-dom"
import Shimmer from 'react-shimmer-effect'

import apiResponse from '../../../../services/apiResponse'

import DetailBloc from './Blocs/DetailBloc'
import MinioClient from '../../../../services/minioClient'
import moment from "moment"

class IndexView extends Component {

    timer
    detailBloc = new DetailBloc();
    minioClient = new MinioClient()
    constructor(props) {
        // const queryParams = new URLSearchParams(this.props.location.search);
        super(props)
        this.state = {
            tooltip: false,
            tooltipStyle: {
                marginBottom: 2,
                backgroundColor: "#000",
                color: "#FFF",
                border: "1px solid #000",
            },
            dataForm: {},
            positionOption: [],
            positionFilter: {
                filter_value: "",
                page_number: 1,
                page_size: 50,
                sort_order: {
                    column: 'position_id',
                    order: 'asc' 
                }
            },
            detail:[],
            month:'',
            year:2024,
            special_allowance_summary_employee_full_name: '',
            special_allowance_summary_work_result: '',
            special_allowance_summary_work_behavior: '',
            special_allowance_summary_final_result: '',
            special_allowance_summary_skp_file_path: '',
            dokumen_skp:[],
            docfiles:[],
        }
    }
    // previewDocument(urlPath) {
    //     // alert(urlPath)
    //     this.setState({
    //         loading: true
    //     })
    //     this.minioClient.get(urlPath).then((url) => {
    //         this.setState({
    //             loading: false
    //         })
    //         alert(url)
    //         window.open(url, "_blank")
    //     })
    // }

    dateParse = (input) =>{
        let res = "-";
        if (input != "" && input != null){
            res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    loadDetail = async () => {
        // const queryParams = new URLSearchParams(this.props.location.search);
        console.log(this.props.uuid)
        // console.log(this.queryParams.get("uuid"))
        // const uuid = queryParams.get("uuid");
        // const queryParams = new URLSearchParams(this.props.location.search)
        // await this.detailBloc.fetchDetail({ uuid: this.queryParams.get("uuid") })
    }

    getMonth = (angkaBulan) => {
        const months = [
            "Januari",
            "Februari",
            "Maret",
            "April",
            "Mei",
            "Juni",
            "Juli",
            "Agustus",
            "September",
            "Oktober",
            "November",
            "Desember",
        ];
            return months[angkaBulan-1];
    }

    componentDidMount() {
        // this.loadDetail()
        console.log(this.state.docfiles)
        this.detailBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    console.log(result.data.response)
                    console.log('result..............................................')
                    // debugger
                    this.setState(
                        {
                            detail: result.data.response.data,
                            month: this.getMonth(result.data.response.data.special_allowance_summary_month),
                            year: result.data.response.data.special_allowance_summary_year,
                            special_allowance_summary_employee_full_name: result.data.response.data.special_allowance_summary_employee_full_name,
                            special_allowance_summary_work_result: result.data.response.data.special_allowance_summary_work_result,
                            special_allowance_summary_work_behavior: result.data.response.data.special_allowance_summary_work_behavior,
                            special_allowance_summary_final_result: result.data.response.data.special_allowance_summary_final_result,
                            special_allowance_summary_skp_file_path: result.data.response.data.special_allowance_summary_skp_file_path,
                            dokumen_skp:result.data.response.result,
                            docfiles:result.data.response.docfiles
                        })
                    break
                default:
                    break
            }
        }) 
        const queryParams = new URLSearchParams(window.location.search);
        this.detailBloc.fetchDetail({uuid: queryParams.get('uuid') })      

    }

    componentWillUnmount() {
        this.detailBloc.detailChannel?.unsubscribe()
    }

   customFormRow = (labelText, detailData, isLoading) => {
        return (
          <Row className="mb-3">
            <label htmlFor="name" className="col-md-3 col-form-label">
              {labelText}
            </label>
            <Col md="3">
              {isLoading ? (
                <Shimmer>
                  <div
                    style={{
                      width: '480px',
                      height: '16px',
                      alignSelf: 'center',
                      borderRadius: '8px',
                      marginTop: 'calc(0.47rem + 1px)',
                      marginBottom: 'calc(0.47rem + 1px)',
                      fontSize: 'inherit',
                      lineHeight: '1.5',
                    }}
                  />
                </Shimmer>
              ) : (
                <Label className="col-form-label">{detailData || '-'}</Label>
              )}
            </Col>
          </Row>
        );
      };

    render() {
        const { detail } = this.state
        return (
            <Fragment>
                <Container fluid>
                    <Card>
                        <CardBody>
                            <div className="float-end">
                                <Link to={`/kepegawaian/skp_tunjangan_khusus.html`}>
                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                </Link>
                            </div>
                            <CardTitle>Detail Mapping Kelas Pegawai</CardTitle>
                            <hr />
                            {/* {this.customFormRow("Bulan", this.getMonth(detail?.employee_list?.special_allowance_summary_month), !detail) }
                            {this.customFormRow("Nip", detail?.employee_list?.employee_nip, !detail) }
                            {this.customFormRow("Nama", detail?.employee_list?.employee_name, !detail)}
                            {this.customFormRow("Grade Tunkin", detail?.mapping_grade_tunsus_grade_tunkin, !detail)}
                            {this.customFormRow("Grade Tunsus", detail?.mapping_grade_tunsus_grade_tunsus, !detail)} */}
                            <Row className="mb-3">
                                <label className="col-md-2">
                                Bulan
                                </label>
                                <Col md="8">
                                    {
                                        this.state.detail ?
                                            <>{this.state.month !== "" ? this.state.month : '-'}</>
                                        : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                                    }
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <label className="col-md-2">
                                Tahun
                                </label>
                                <Col md="8">
                                    {
                                        this.state.detail ?
                                            <>{this.state.year !== "" ? this.state.year : '-'}</>
                                        : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                                    }
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <label className="col-md-2">
                                Pegawai
                                </label>
                                <Col md="8">
                                    {
                                        this.state.detail ?
                                            <>{this.state.special_allowance_summary_employee_full_name !== "" ? this.state.special_allowance_summary_employee_full_name : '-'}</>
                                        : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                                    }
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <label className="col-md-2">
                                Hasil Kerja
                                </label>
                                <Col md="8">
                                    {
                                        this.state.detail ?
                                            <>{this.state.special_allowance_summary_work_result !== "" ? this.state.special_allowance_summary_work_result : '-'}</>
                                        : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                                    }
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <label className="col-md-2">
                                Perilaku Kerja
                                </label>
                                <Col md="8">
                                    {
                                        this.state.detail ?
                                            <>{this.state.month !== "" ? this.state.special_allowance_summary_work_behavior : '-'}</>
                                        : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                                    }
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <label className="col-md-2">
                                Hasil Akhir
                                </label>
                                <Col md="8">
                                    {
                                        this.state.detail ?
                                            <>{this.state.special_allowance_summary_final_result !== "" ? this.state.special_allowance_summary_final_result : '-'}</>
                                        : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                                    }
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <label className="col-md-2">
                                    File SKP
                                </label>
                                <Col md="8">
                                {this.state.dokumen_skp.map((data, index) => {
                                    return (
                                        <Row className="mb-3">
                                        <Col md="12">
                                            
                                            {data.path ? (
                                            <>
                                                {data.path !== "" ? (
                                                <a
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    class="btn btn-sm btn-primary"
                                                    href={data.path}
                                                >
                                                    <i className="uil-file-download"></i>{" "}
                                                    Download File {' - '+ data?.name}
                                                </a>
                                                ) : (
                                                "Tidak ada dokumen"
                                                )}
                                            </>
                                            ) : (
                                                "Tidak ada dokumen"
                                            )}
                                        </Col>
                                        </Row>
                                    );
                                    })}
                                </Col>
                            </Row>
                            
                        </CardBody>
                    </Card>

                </Container>
               
            </Fragment>
        )
    }

}

export default IndexView